<template>
  <div>
    <!-- <a-cascader :options="options" :field-names="fieldNames" :disabled="disabled" v-model="value" placeholder="省/市/区" @change="handleChange" /> -->
    <!-- <el-button @click="ceshi">
      格式转换
    </el-button> -->
    <a-cascader
      v-model="selectedValue"
      :options="options"
      :load-data="loadData"
      :lazy="true"
      placeholder="请选择地区"
      @change="handleChange"
      style="width: 300px"
    />
  </div>
</template>

<script>
import { Cascader } from 'ant-design-vue'

export default {
  name: 'Index',
  components: {
    ACascader: Cascader,
  },
  props: {
    valueArr: {
      type: Array,
    },
    type: {
      type: String,
      default: 'en',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedValue: [],
      // 初始选项 - 必须设置 isLeaf 为 false 才能触发懒加载
      options: [],
    }
  },
  watch: {
    valueArr: {
      handler(val) {
        if (val && val.length) {
          this.updateSelectedValue(val)
        }
      },
      immediate: true,
    },
    list: {
      handler(val) {
        if (val) {
          this.options = val.map(item => {
            return {
              value: item.regionId,
              label: item.name,
              isLeaf: false,
            }
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 懒加载数据方法
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      // 模拟API请求 - 替换为你的实际API调用
      this.fetchData(targetOption.value)
        .then(children => {
          targetOption.loading = false
          targetOption.children = children
          // 必须这样更新才能触发视图刷新
          this.options = [...this.options]
        })
        .catch(error => {
          targetOption.loading = false
          console.error('加载失败:', error)
        })
    },

    fetchData(parentId) {
      return new Promise(resolve => {
        this.$axios
          .get('/auxiliary/admin/region', {
            params: {
              page: 1,
              limit: 10000,
              parentId,
            },
          })
          .then(res => {
            resolve(
              res.data.map(item => {
                return {
                  value: item.regionId,
                  label: item.name,
                  isLeaf: item.level == 3 ? true : false,
                }
              })
            )
          })
      })
    },
    findNestedElement(options, value) {
      const list = []
      function search(currentLevel, index) {
        if (!Array.isArray(currentLevel) || index >= value.length) return

        for (const element of currentLevel) {
          if (element.value === value[index]) {
            list.push(element)
            // 如果还有下一级需要查找，并且当前元素有 children 属性
            if (index + 1 < value.length && Array.isArray(element.children)) {
              search(element.children, index + 1)
            }
          }
        }
      }
      // 检查 value 是否为数组
      if (!Array.isArray(value) || value.length === 0 || !Array.isArray(options)) {
        return list
      }
      // 开始递归查找
      search(options, 0)

      return list
    },
    handleChange(value) {
      const list = this.findNestedElement(this.options, value)
      if (list && list.length) {
        this.$emit('provincesValueChang', list)
      }
    },
    async updateSelectedValue(valueArr) {
      if (!this.options || this.options.length === 0) {
        setTimeout(() => {
          this.updateSelectedValue(valueArr)
        }, 100)
      }
      let currentOptions = this.options

      for (let i = 0; i < valueArr.length; i++) {
        const currentValue = valueArr[i]
        const targetOption = currentOptions.find(opt => opt.label === currentValue)
        if (targetOption) {
          this.selectedValue[i] = targetOption.value
          if (targetOption && !targetOption.level != 3) {
            await this.loadOptionChildren(targetOption)
            currentOptions = targetOption.children
          } else if (targetOption?.children) {
            currentOptions = targetOption.children
          }
        }
      }
    },
    async loadOptionChildren(option) {
      option.loading = true
      try {
        const children = await this.fetchData(option.value)
        option.children = children
        option.loading = false
        this.options = [...this.options] // 触发视图更新
      } catch (error) {
        option.loading = false
        console.error('加载失败:', error)
      }
    },
  },
}
</script>
